module.exports = __webpack_public_path__ + "static/media/8th_C.f251f46f.png";